module.exports = __webpack_public_path__ + "static/media/boris-400-400.2259168a.webp";